import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

class RenderRank extends Component {
  render() {
    if(!this.props.args.cellData) return '-';
    return(
      <Grid container justify="center">
        {/*<Grid 
          item 
          xs={6}>
          {this.props.args.cellData.rank}
        </Grid>*/}
        <Grid
          item 
          xs={6}>
          {this.props.args.cellData.points}
        </Grid>
      </Grid>
    )
  }
}

RenderRank.propTypes = {
  args: PropTypes.object.isRequired
}

export default RenderRank;